'use strict';

var React = require('react');
var components_Customise_CustomizeContext_types = require('./components/Customise/CustomizeContext/types.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const initialState = {
    id: "",
    name: "",
    selectedAddons: {},
    selectedVariants: {},
    currentStep: 1,
    totalSteps: 2,
    variantsV2: {
        pricingModelHash: {},
        variantsHash: {},
        addonsHash: {},
    },
    pricingModelKey: "",
    validVariants: [],
    validAddons: [],
    updatingExistingCustomization: false,
    version: 2,
};
const ACTION_HANDLERS = {
    [components_Customise_CustomizeContext_types.SHOW_CUSTOMIZE_MODAL]: (state, action) => (Object.assign(Object.assign({}, initialState), action.payload)),
    [components_Customise_CustomizeContext_types.HIDE_CUSTOMIZE_MODAL]: () => initialState,
    [components_Customise_CustomizeContext_types.TOGGLE_ADDON]: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
    [components_Customise_CustomizeContext_types.UPDATE_VARIANT]: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
    [components_Customise_CustomizeContext_types.NEXT_STEP]: (state) => (Object.assign(Object.assign({}, state), { currentStep: state.currentStep + 1 })),
    [components_Customise_CustomizeContext_types.CHANGE_STEP]: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
};
const reducer = (state, action) => {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};
const CustomizeContext = React__default.default.createContext({
    state: initialState,
    dispatch: () => null,
});
const CustomizeContextProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    return (React__default.default.createElement(CustomizeContext.Provider, { value: { state, dispatch } }, children));
};

exports.CustomizeContext = CustomizeContext;
exports.CustomizeContextProvider = CustomizeContextProvider;
//# sourceMappingURL=CustomizeContext-CpkrEQ6Z.js.map
